import request from '../../../shared/request'

export function getJobEstimates(job_id) {
  return request(`/job/estimates/${job_id}/`)
}

export function getEstimateSections(estimate_id) {
  return request(`/job/estimates/${estimate_id}/section`)
}

export function getEstimateItems(estimate_id) {
  return request(`/job/estimates/${estimate_id}/item`)
}

export function createJobEstimate(payload) {
  return request(`/job/estimates/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobEstimate(payload) {
  return request(`/job/estimates/${payload.estimate_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobEstimate(payload) {
  return request(`/job/estimates/${payload.estimate_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/estimates.js